// Styled components
import { Box, InputAdornment, InputBase, Paper, Popper, styled } from "@mui/material";

export const ContainerBox = styled(Box)(() => ({
  position: "relative",
}));
export const ConditionSubjectInputAdornment = styled(InputAdornment)(({ theme }) => ({
  cursor: "pointer",
  marginLeft: 0,
  marginRight: theme.spacing(-1),
}));
export const ConditionSubjectInputBase = styled(InputBase)(({ theme }) => ({
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  // The input slot holds a two line label instead of a single line input, so the default input
  // metrics (fixed one line height, vertical padding) have to go.
  "& .MuiInputBase-input": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "auto",
    padding: 0,
  },
}));
export const ConditionSubjectPopper = styled(Popper)(() => ({
  width: "100%",
  zIndex: 1000,
}));
export const ConditionSubjectPaper = styled(Paper)(() => ({
  height: "420px",
  minWidth: "420px",
  width: "100%",
  overflow: "auto",
  zIndex: 1,
}));
const labelLine = {
  display: "block",
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: "left",
  lineHeight: 1.2,
} as const;

export const ConditionSubjectCategoryLine = styled("span")(({ theme }) => ({
  ...labelLine,
  fontSize: theme.typography.pxToRem(10),
  color: theme.palette.grey[600],
}));
export const ConditionSubjectValueLine = styled("span", {
  shouldForwardProp: (prop) => prop !== "isPlaceholder",
})<{ isPlaceholder?: boolean }>(({ theme, isPlaceholder }) => ({
  ...labelLine,
  color: isPlaceholder ? theme.palette.custom.jet[500] : undefined,
  opacity: isPlaceholder ? 0.42 : undefined,
}));
